import { addDays, format, isWeekend, parseISO, startOfToday } from "date-fns";

export const SLOTS = [
  { id: "morning", label: "Morning Session", time: "8:00 AM – 12:00 PM" },
  { id: "afternoon", label: "Afternoon Session", time: "1:00 PM – 5:00 PM" },
  { id: "evening", label: "Evening Session", time: "5:00 PM – 9:00 PM" },
];

export const SPACES = [
  {
    id: "Main Stage",
    tag: "01",
    blurb: "The big open floor for video shoots, live sets and anything that needs room to move.",
    image: "https://images.unsplash.com/photo-1630916079851-de145947bde3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  },
  {
    id: "Podcast",
    tag: "02",
    blurb: "A dedicated room for conversations, interviews and recorded shows.",
    image: "https://images.unsplash.com/photo-1659083725992-9d88c12e719c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
  {
    id: "ASMR Room",
    tag: "03",
    blurb: "A quiet, close-up space made for whisper-level audio and detail work.",
    image: "https://images.unsplash.com/photo-1633933714442-a68def2d5849?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1668536618600-754ef972b9b3?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000";

export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

export const slotById = (id) => SLOTS.find((s) => s.id === id);

export function nextWeekday(from = startOfToday(), closed = new Set()) {
  let d = from;
  while (isWeekend(d) || closed.has(toISODate(d))) d = addDays(d, 1);
  return d;
}

export const toISODate = (d) => format(d, "yyyy-MM-dd");
export const prettyDate = (iso) => format(parseISO(iso), "EEE, d MMM yyyy");
export const isPastDate = (iso) => parseISO(iso) < startOfToday();
